export enum TrackerAddFormTemplate {
    ACTIVITY = "add-activity-form",
    BOOLEAN = "add-boolean-form",
    EMPTY = "add-empty-form",
    FOOD = "add-food-form",
    MANUAL = "add-manual-form",
    PUSH = "add-push-form",
    RANGE = "add-range-form",
    COMPLETE = "add-complete-form"
}